import { contentLanguages } from 'lib/languages'
import { formatMultiLanguageField } from 'lib/utils'
import { ProductAttributeGroup } from 'types/api/product'
import { v4 as getRandomId } from 'uuid'
import { convertBooleanToString } from 'views/Product/utils'

export const useProductAttribute = (
  productAttributeGroups: ProductAttributeGroup[]
) => {
  if (productAttributeGroups.length === 0) {
    const attributeId = getRandomId()
    const id = getRandomId()
    return [
      {
        productAttributeGroupName: {
          options: formatMultiLanguageField(undefined),
          contentLanguage: contentLanguages[0],
        },
        productAttribute: [{ id: attributeId }],
        id,
      },
    ]
  }
  const formatAttributeGroup = productAttributeGroups.map((group) => {
    const attributeGroupId = getRandomId()
    const formatAttribute =
      group.productAttribute?.length > 0
        ? group.productAttribute?.map((attribute) => {
            const id = getRandomId()
            return {
              ...(attribute.productAttributeValueString && {
                productAttributeValueString: {
                  options: formatMultiLanguageField(
                    attribute.productAttributeValueString
                  ),
                  contentLanguage: contentLanguages[0],
                },
              }),
              ...(attribute.productAttributeValueNumeric && {
                productAttributeValueNumeric:
                  attribute.productAttributeValueNumeric,
              }),
              ...(convertBooleanToString(
                attribute.productAttributeValueBoolean
              ) && {
                productAttributeValueBoolean:
                  attribute.productAttributeValueBoolean,
              }),
              isFacetAttribute: attribute.isFacetAttribute,
              productAttributeName: {
                options: formatMultiLanguageField(
                  attribute.productAttributeName
                ),
                contentLanguage: contentLanguages[0],
              },
              id,
            }
          })
        : [{ id: getRandomId() }]

    return {
      productAttributeGroupName: {
        options: formatMultiLanguageField(group.productAttributeGroupName),
        contentLanguage: contentLanguages[0],
      },
      productAttribute: formatAttribute,
      id: attributeGroupId,
    }
  })
  return formatAttributeGroup
}
